import { post, get } from "./base"

export default{
    addRecommendation: (data,headers)=>{
        return post(`${window.apiUrl}Recommendation/add-recommendation`,data,headers)
    },
    getRecommendation: (pageSize=1000, pageNo=0) => get(`${window.apiUrl}Recommendation/get-recommendations`,{}, true) 
}